import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
    name: 'bundleDownloadUrl',
    standalone: false
})
export class BundleDownloadUrlPipe implements PipeTransform {

  transform(bundleKey: string): string {
    return `${environment.baseUrl}/bundles/${bundleKey}`;
  }
}
